// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"468":"0640c957","496":"a73aa1d4"}[chunkId] + ".chunk.js";
};